import { types } from "../types/types";

export const setRequestId = (payload: string | undefined) => ({
    type: types.setRequestId,
    payload,
});
